import React from 'react';
import * as Routes from '@/modules/routes';
import Drawer from '@/components/ui/Drawer';
import { AssignmentDrawerContent } from './AssignmentDrawerContent';
import useGradesTableStore from '../store/useGradesTableStore';
import AssignmentsRow from './Rows/AssignmentsRow';
import StudentRow from './Rows/StudentsRow';
import Legend from './Legend';
import LMSSyncStatusToolbar from '../LMSSyncStatusToolbar';
import styles from './styles.module.scss';
import { applyGradesFilters } from './utils';
import Spinner from '../../../common/Modal/Spinner';

const Table = () => {
  const students = useGradesTableStore(state => state.students);
  const submissions = useGradesTableStore(state => state.submissions);
  const classroom = useGradesTableStore(state => state.classroom);
  const programId = useGradesTableStore(state => state.programId);
  const isLoading = useGradesTableStore(state => state.isLoading());
  const isLoadingSubmissions = useGradesTableStore(state => state.isLoadingSubmissions);
  const filters = useGradesTableStore(state => state.filters);
  const filteredStudents = applyGradesFilters({
    gradingStatusFilter: filters.gradingStatus,
    students,
    submissions,
  });

  // A grading-status filter decides which student rows exist from submissions, so it can't skeleton
  // cell by cell — rows would appear and vanish once submissions land.
  const isAwaitingRows = isLoading || (filters.gradingStatus.length > 0 && isLoadingSubmissions);

  if (isAwaitingRows) return (<Spinner isLoading={isAwaitingRows} />);

  if (students.length < 1) {
    const url = Routes.new_teacher_classroom_student_path(classroom.id, { program_id: programId });

    return (
      <div className="tw-mt-12">
        <p className="tw-mb-3"> You have a studentless classroom! Click Add Students to finish creating your class </p>
        <a className="btn btn--green" href={url}> Add Students </a>
      </div>
    );
  }

  return (
    <Drawer handleOnly>
      <figure>
        <div className={styles.assignmentsGradesTableWrapper}>
          <table className={styles.assignmentsGradesTable}>
            <thead>
              <AssignmentsRow />
            </thead>
            <tbody>
              {filteredStudents.map(student => (
                <StudentRow
                  key={`student-row-${student.id}`}
                  student={student}
                />
              ))}
            </tbody>
          </table>
        </div>
        <figcaption>
          {filteredStudents.length > 0 && <Legend />}
        </figcaption>
        <LMSSyncStatusToolbar />
      </figure>
      <AssignmentDrawerContent />
    </Drawer>
  );
};

export default Table;
